module.exports = __webpack_public_path__ + "static/media/phonetext.2db15b21.jpg";